import { render } from "./PlayCamera.vue?vue&type=template&id=2678731a&scoped=true"
import script from "./PlayCamera.vue?vue&type=script&lang=js"
export * from "./PlayCamera.vue?vue&type=script&lang=js"

import "./PlayCamera.vue?vue&type=style&index=0&id=2678731a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2678731a"]])

export default __exports__